<template>
<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.08367 4.12501H3.02867L5.03534 2.11835C5.37367 1.78001 5.37367 1.22001 5.03534 0.88168C4.69701 0.543346 4.13701 0.543346 3.79867 0.88168L0.298672 4.38168C-0.0396614 4.72001 -0.0396614 5.28001 0.298672 5.61835L3.79867 9.11835C3.97367 9.29335 4.19534 9.37501 4.41701 9.37501C4.63867 9.37501 4.86034 9.29335 5.03534 9.11835C5.37367 8.78001 5.37367 8.22001 5.03534 7.88168L3.02867 5.87501H9.08367C9.56201 5.87501 9.95867 5.47835 9.95867 5.00001C9.95867 4.52168 9.56201 4.12501 9.08367 4.12501Z" fill="#292E36"/>
</svg>

  </template>
  <script lang="ts" setup>
  
  </script>
  